export const setComplaintData = (data) => {
  const action = { type: "SET_COMPLAINT_DATA", data: data };
  return action;
};

export const resetComplaintData = () => {
  const action = { type: "RESET_COMPLAINT_DATA" };
  return action;
};
